import {LocalAddress} from '../../models';
import {makeReducer} from '../../redux-toolbelt';

import {setLocalAddress} from './localAddressActions';

type LocalAddressState = LocalAddress | null;

export default makeReducer<LocalAddressState, ReturnType<typeof setLocalAddress>['payload']>(setLocalAddress);
